import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <div className="footer">
        <div className="container pt-5 pb-5">
          <div className="row">
            <div className="col-md-8 footer-section">
              <div className="footer-contact">
                <div className="footer-logo">
                  <h2>Bishal Gaire</h2>
                </div>
                <ul>
                  {/* <li>Phone: +977–3456789</li> */}
                  <li>Email: gairebishal@gmail.com</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-social-icon pt-md-4">
                <a
                  href=" https://www.facebook.com/bishal.gaire.16"
                  target="__blank"
                >
                  <li className="ficon">
                    <FaFacebookF className="social_icon" />
                  </li>
                </a>

                <li className="ficon">
                  <FaTwitter className="social_icon" />
                </li>
                <li className="ficon">
                  <FaLinkedinIn className="social_icon" />
                </li>
                <a
                  href="https://www.youtube.com/@bishalgaire3476"
                  target="__blank"
                >
                  <li className="ficon">
                    <FaYoutube className="social_icon" />
                  </li>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copy-right container pt-2">
        <div className="copy">
          <p>&copy;2023.bishalgarie.com.All Rights Reserved. </p>
        </div>
        <div className="powered_by">
          <p>
            Powered By{" "}
            <a href="https://smartinnovation.com.np/" target="__blank">
              Smart Innovation
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
